// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_DESCRIPTION_DEFAULT_FALLBACK = "Modr\u00fd kon\u00edk - str\u00e1nka pre mami\u010dky a bud\u00face mami\u010dky, baz\u00e1r na detsk\u00e9 oble\u010denie, hra\u010dky, autoseda\u010dky, ko\u010d\u00edky";
export const SEO_TITLE_DEFAULT_FALLBACK = "Modr\u00fd kon\u00edk - Tehotenstvo, p\u00f4rod a die\u0165a - v\u0161etko pre mami\u010dky a bud\u00face mami\u010dky";
